<template>
    <div>
        <div class="text-center" :class="alarmDisplay.color">
            <font-awesome-icon
                :icon="['fas', alarmDisplay.icon]"
                size="xl"
            />
        </div>

        <div class="text-center">
            {{ alarmDisplay.text }}
        </div>
    </div>

    <div
        v-if="alarmTypeValue == 37"
        class="d-inline-flex align-items-center gap-1 text-muted fst-italic small"
    >
        <InfoDisplay
            :toolTip="'Le véhicule peut être démarré pendant 30 secondes'"
            :icon="'info'"
        />

        <span v-if="badge">
            {{ badge ? badge.ref : "" }}
            :
            {{ badge.lastName + " " + badge.firstName }}
        </span>

        <span v-else>
            {{ alarm.data ? "#" + alarm.data : "TAG main libre détecté" }}
        </span>
    </div>
</template>

<script>
import BadgeService from '@/services/badge.service.js'
import FormatHelper from '@/helpers/format.helper.js'
import InfoDisplay from '@/components/display/InfoDisplay.vue'

import {
    resolveAlarmDisplay,
    getAlarmTypeValue
} from '@/helpers/alarmDisplay.helper.js'

export default {
    props: {
        alarm: {},
        balise: {
            default: null
        },
    },

    components: {
        InfoDisplay
    },

    data() {
        return {
            badge: null,
        }
    },

    mounted() {
        if (this.alarmTypeValue == 37 && this.alarm.data != null) {
            this.getBadgeInfo();
        }
    },

    methods: {
        getBadgeInfo() {
            BadgeService.getBadgeByNumber(this.alarm.data)
                .then(response => {
                    this.badge = FormatHelper.badgeInfoFormat(response.data);
                })
                .catch(e => {
                    console.log(e);
                });
        },
    },

    computed: {
        alarmTypeValue() {
            return getAlarmTypeValue(this.alarm);
        },

        alarmDisplay() {
            return resolveAlarmDisplay(this.alarm, this.balise);
        }
    },
}
</script>